import { useApolloClient, useMutation } from '@apollo/client/react';
import { ConfirmationDialog } from '@optools/components/dialog/confirmation-dialog';
import { Button } from '@optools/components/ui/button';
import { COPYRIGHT_STREAM_FRAGMENT } from '@optools/services/operator-gateway/btc/fragments';
import { PROVISION_COPYRIGHT_STREAM } from '@optools/services/operator-gateway/btc/mutations';
import { CopyrightStreamProvision } from '@optools/services/operator-gateway/types/generated/graphql';
import { toast } from 'sonner';

export function ProvisionCopyrightStream(props: CopyrightStreamProvision) {
  const client = useApolloClient();
  const [provisionCopyrightStream, { error, loading }] = useMutation(PROVISION_COPYRIGHT_STREAM, {
    onCompleted: ({ provisionCopyrightStream }) => {
      if (provisionCopyrightStream) {
        toast.success('Provision Success', {
          description: 'Copyright Stream successfully provisioned.',
        });
      } else {
        toast.error('Provision Error', {
          description: 'Failed to provision Copyright Stream. Please try again.',
          duration: Infinity,
        });
      }
    },
    update: (cache, { data }) => {
      const newCopyrightStream = data?.provisionCopyrightStream;
      if (newCopyrightStream) {
        cache.modify({
          fields: {
            copyrightStreams(existingCopyrightStreams = []) {
              const newCopyrightStreamRef = cache.writeFragment({
                data: newCopyrightStream,
                fragment: COPYRIGHT_STREAM_FRAGMENT,
              });
              return [...existingCopyrightStreams, newCopyrightStreamRef];
            },
          },
        });
      }
    },
    variables: { stream: props },
  });

  return (
    <>
      {error?.message === 'Failed to fetch' ? (
        <>
          <p className="text-sm">
            The request may have timed out. Try refreshing the streams to see if the newly
            provisioned stream is available.
          </p>
          <Button onClick={() => client.cache.evict({ fieldName: 'copyrightStreams' })}>
            Refresh Copyright Streams
          </Button>
        </>
      ) : (
        <>
          {loading ? (
            <p className="text-sm">
              Provisioning a stream could take up to 30 seconds. Please do not leave this page.
            </p>
          ) : (
            <h1 className="text-sm">No Copyright Stream</h1>
          )}
          <ConfirmationDialog
            description="Are you sure you want to provision a Copyright Stream?"
            title="Provision Copyright Stream"
            onConfirm={() => provisionCopyrightStream()}>
            <Button disabled={loading} loading={loading}>
              Provision Stream
            </Button>
          </ConfirmationDialog>
        </>
      )}
    </>
  );
}
